import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Stack, Typography} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {constance} from "../../common/constance/constance";
import {common} from "../../common/common";
import {DateTime} from "luxon";


export default function EventConfirmDialog() {
    console.log('[EventConfirmDialog]');

    const [state, setState] = useState({
        open: false,
        isWinning: false,
    })
    useEffect(() => {
        let attendanceWinningEvent = common.getCookie(constance.cookieName.attendanceWinningEvent);
        let getAttendanceWinningEvent: boolean = false;
        let now = new Date();
        let date = DateTime.fromMillis(now.getTime()).toFormat('yyyy-MM');
        if (attendanceWinningEvent == null) {
            getAttendanceWinningEvent = true;
        } else {
            let eventValue: { dateFormat: string, checkYN: string } = JSON.parse(attendanceWinningEvent);
            if (eventValue.dateFormat !== date) {
                getAttendanceWinningEvent = true;
            }
        }

        if (getAttendanceWinningEvent) {
            axios(constance.api.checkWinningEvent).then(value => {

                /* 당첨 확인 쿠키 저장 */
                common.setCookie(constance.cookieName.attendanceWinningEvent,
                    JSON.stringify({dateFormat: date, checkYN: 'Y'}),
                    100000)

                setState({
                    ...state,
                    open: state.isWinning? true : false,
                    isWinning: value.data.lastAttendanceWinningHistory ? true : false,
                })
            })
        }
    }, [])

    const handleClose = () => {
        setState({
            ...state,
            open: false,
        });
    };


    return (
        <div>
            <Dialog open={state.open} onClose={handleClose} sx={{maxHeight: '100vh'}}>
                <DialogTitle>
                    <Box sx={{display: 'flex'}}>
                        <Typography variant={'h5'} align={"center"}>
                            {/*{`출석 이벤트 당첨 안내`}*/}
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Stack sx={{width: {xs: 250, sm: 300, md: 400}}}>
                            {
                                state.isWinning ? (
                                    <Stack sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: 346,
                                        backgroundImage: 'url(/images/congratulations.png)',
                                        backgroundSize: 'cover',
                                    }}>
                                        <Typography variant={'h4'} sx={{ml: 2}}>축하합니다!</Typography>
                                        <Typography variant={'h6'} sx={{ml: 2, mt: 2}}>출석체크 이벤트에 당첨되셨습니다.</Typography>
                                        <Typography variant={'h6'} sx={{ml: 2}}>소정의 선물이 지급될 예정입니다.</Typography>
                                    </Stack>
                                ) : ''                                /*
                                <Stack sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    height: 346,
                                    backgroundImage: 'url(/images/no-luck.png)',
                                    backgroundSize: 'cover',
                                }}>

                                    <Typography variant={'h6'} sx={{ml: 0}}>출석체크 이벤트에</Typography>
                                    <Typography variant={'h6'} sx={{ml: 2}}>아쉽게도 당첨되지 않으셨습니다.</Typography>
                                    <Typography variant={'h6'} sx={{ml: 0, mt: 1}}>다음에 도전해주세요.</Typography>
                                </Stack>
                                */
                            }
                        </Stack>
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    {/*<Button onClick={handleClose}>닫기</Button>*/}
                </DialogActions>
            </Dialog>
        </div>
    );
}